module.exports = __webpack_public_path__ + "img/purim-2019-thumbnail.32c86cf3.jpg";